<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý xuất
            hàng</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Mã phiếu xuất:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập mã phiếu xuất" v-model="search.cCode" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên phiếu xuất:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên phiếu xuất " v-model="search.cTenPhieuXuat" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Ngày tạo:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-date-picker  format="DD/MM/YYYY" v-model="search.createDate" type="daterange"
                  range-separator="-" start-placeholder="Từ ngày" end-placeholder="đến ngày" style="width: 100%" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value=""></el-option>
                  <el-option label="Chờ xác nhận" value="0"></el-option>
                  <el-option label="Xác nhận" value="1"></el-option>
                  <el-option label="Đã hủy" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="findPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <el-button type="primary" plain outline native-type="submit" @click="handleAdd" style="margin: 5px 10px;">
          <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
          <span class="btn-inner--text">&nbsp;Tạo phiếu xuất</span>
        </el-button>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" fit stripe
            highlight-current-row v-loading="isLoadingTable">
            <el-table-column prop="cCode" label="Mã phiếu xuất" width="120"></el-table-column>
            <el-table-column prop="odooName" label="Tên phiếu xuất" min-width="200" header-align="center">
              <template #default="scope">
                <el-button type="text"
                  @click="$router.push({ name: 'DetailExport', params: { id: scope.row.nMaPhieuXuat } })">{{
                    scope.row.cTenPhieuXuat }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" width="150" align="center">
              <template #default="scope">
                <span v-if="scope.row.dNgayTao">{{
                  moment(scope.row.dNgayTao).format("HH:mm - DD/MM/YYYY")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="danger" v-if="scope.row.nTrangThai === 2" :size="size">Đã hủy</el-tag>
                <el-tag type="success" v-else-if="scope.row.nTrangThai === 1" :size="size">Xác nhận</el-tag>
                <el-tag v-else-if="scope.row.nTrangThai === 0" :size="size">Chờ xác nhận</el-tag>
              </template>
            </el-table-column>

            <!-- Button hành động -->
            <el-table-column width="150" align="center" label="hành động">
              <template #default="scope">
                <el-button type="text" title="Xác nhận" v-if="scope.row.nTrangThai === 0"
                  @click="handleOpenDialogConfirm(scope.row.nMaPhieuXuat)">
                  <i class="fa fa-check" style="color: green" />
                </el-button>
                <el-button type="text" title="Chi tiết"
                  @click="$router.push({ name: 'DetailExport', params: { id: scope.row.nMaPhieuXuat } })">
                  <i class="fa fa-eye" />
                </el-button>

                <el-button type="text" title="Hủy bỏ" v-if="scope.row.nTrangThai === 0"
                  @click="handleDelete(scope.row.nMaPhieuXuat)">
                  <i class="fa fa-trash" style="color: red" />
                </el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <el-dialog :show.sync="dialog" class="modalTemp p-0" dataBackDrop="static">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">Xác nhận phiếu xuất hàng</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="dialog = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <div class="tbl">
        <el-table :data="listDetailExport" header-row-class-name="thead-light" :border="true"  fit>
          <el-table-column prop="odooName" label="Sản phẩm">
            <template #default="scope">
              <div style="display: flex; gap: 10px">
                <el-image style="width: 50px; height: 50px" :src="baseUrl + '/product/img/' + scope.row.odooImage1920"
                  :fit="'fill'" />
                <span>{{ scope.row.odooName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Số lượng" prop="nSoLuong" width="180" align="center" />

        </el-table>
      </div>
      <template #footer>
        <el-button type="primary" v-loading.fullscreen.lock="isLoading"
          @click="handleConfirm(listDetailExport[0].nMaPhieuXuat)">
          Xác nhận
        </el-button>
        <el-button outline type="secondary" @click="dialog = false">
          Thoát
        </el-button>
      </template>


    </el-dialog>
  </div>
</template>
<script>
import { baseUrl } from "@/utils/global"
import _ from 'lodash';
import moment from "moment/moment";
import { useStore } from "vuex";
import { Inventory } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {

  data() {
    return {
      store: useStore(),
      isLoading: false,
      pageRequest: { pageNum: 1, pageSize: 10 },
      tableData: [],
      baseUrl: baseUrl,
      //
      search: {
        cCode: "",
        cTenPhieuXuat: "",
        createDate: [],
        nTrangThai: ""
      },
      dialog: false,
      listDetailExport: [],
      isLoadingTable: false,


    }
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: 'newExport' })
    },

    async findPage() {
      this.isLoadingTable = true
      let fromDate = ""
      let toDate = ""

      if (this.search.createDate && this.search.createDate.length === 2) {
        fromDate = moment(this.search.createDate[0]).format("DD/MM/YYYY")
        toDate = moment(this.search.createDate[1]).format("DD/MM/YYYY")
      }

      this.pageRequest.columnFilters = {
        cCode: { value: this.search.cCode },
        cTenPhieuXuat: { value: this.search.cTenPhieuXuat },
        fromDate: { value: fromDate },
        toDate: { value: toDate },
        nTrangThai: { value: this.search.nTrangThai },
      }

      const res = await this.store.dispatch(Inventory.getExports, this.pageRequest)
      if (res.code === 200) {
        this.tableData = res.data
        this.isLoadingTable = false
      }
    },

    handleSizeChange(val) {
      this.pageRequest.pageSize = val
      this.findPage()
    },

    handleCurrentChange(val) {
      this.pageRequest.pageNum = val
      this.findPage()
    },

    async handleOpenDialogConfirm(id) {
      const res = await this.store.dispatch(Inventory.findExportById, id)
      if (res.code === 200) {
        if (res.data.sysChiTietPhieuXuatList.length > 0) {
          this.listDetailExport = res.data.sysChiTietPhieuXuatList
          this.dialog = true
        } else {
          ElMessage({ message: "Vui lòng thêm sản phẩm", type: "error" })
        }
      }
    },
    async handleConfirm(id) {
      this.isLoading = true
      const res = await this.store.dispatch(Inventory.confirmExport, id)
      if (res.code === 200) {
        ElMessage({ message: "Xác nhận thành công", type: "success" })
        await this.findPage()
        this.isLoading = false
        this.dialog = false
      }
    },

    async handleDelete(id) {
      this.$confirm("Bạn có muốn hủy bỏ phiếu xuất này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(async () => {
          const res = await this.store.dispatch(Inventory.deleteExport, id)
          if (res.code === 200) {
            ElMessage({ message: "Hủy bỏ thành công", type: "success" })
            await this.findPage()
            this.dialog = false
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Hủy bỏ thất bại",
          });
        });
    },

    debounceSearchTenPhieuXuat: _.debounce(function (string) {
      this.findPage()
    }, 500),

    debounceSearchCode: _.debounce(function (string) {
      this.findPage()
    }, 500),
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }

  },
  mounted() {
    this.findPage()

  },
  watch: {
    'search.cCode': function (newV) {
      this.debounceSearchCode(newV)
    },
    'search.cTenPhieuXuat': function (newV) {
      this.debounceSearchTenPhieuXuat(newV)
    }
  }
}
</script>
